import { formatMxn, MOCK_MONEY, MOCK_TOURNAMENT } from "../mockData";
import { Avatar, MockFigure, PanelFrame, Pill } from "./frames";
import { MoneyFlow } from "./MoneyFlow";
import "./FinancePanel.css";

/** Etiquetas reales de AdminFinanceDashboardPage.tsx (tarjetas de resumen). */
const SUMMARY_TILES: { label: string; amount: number }[] = [
  { label: "Pagos recibidos", amount: MOCK_MONEY.collected },
  { label: "Pendiente por cobrar", amount: MOCK_MONEY.pending },
  { label: "Comisión Torneos123", amount: MOCK_MONEY.platformFee },
  { label: "Comisión Mercado Pago", amount: MOCK_MONEY.mpFee },
];

const PENDING_ORDERS = MOCK_MONEY.orders - MOCK_MONEY.paid;

const PANEL_LABEL =
  `Dashboard financiero de ejemplo de la ${MOCK_TOURNAMENT.name}, con Mercado Pago conectado: ` +
  `pagos recibidos ${formatMxn(MOCK_MONEY.collected)}, pendiente por cobrar ${formatMxn(MOCK_MONEY.pending)}, ` +
  `comisión Torneos123 ${formatMxn(MOCK_MONEY.platformFee)}, comisión Mercado Pago ${formatMxn(MOCK_MONEY.mpFee)} ` +
  `y neto ${formatMxn(MOCK_MONEY.net)}. Paola Méndez tiene ${formatMxn(850)} pendiente con el botón para copiar su recordatorio de pago; ` +
  `Diego Salazar pagó ${formatMxn(1250)} por dos categorías con una sola comisión de Torneos123.`;

function CopyGlyph() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="9" y="9" width="11" height="11" rx="2" />
      <path d="M5 15V6a2 2 0 0 1 2-2h9" />
    </svg>
  );
}

/**
 * M4 · Dashboard financiero de la Copa Otoño 2026 (tema oscuro de la app) con
 * M3 (flujo del dinero) encimado abajo: juntos ilustran la escena «Cobro».
 * Sin reembolsos, para que el neto cuadre: $44,000 − $4,752 − $2,004.
 */
export function FinancePanel() {
  return (
    <div className="mk-finance">
      <MockFigure label={PANEL_LABEL} caption={false} className="mk-finance__fig">
        <PanelFrame
          className="mk-finance__panel"
          title={`Dashboard financiero · ${MOCK_TOURNAMENT.name}`}
          badge="Mercado Pago conectado ✓"
        >
          <div className="mk-finance__tiles">
            {SUMMARY_TILES.map((tile) => (
              <div key={tile.label} className="mk-finance__tile">
                <strong className="mk-finance__value">{formatMxn(tile.amount)}</strong>
                <span className="mk-finance__label">{tile.label}</span>
              </div>
            ))}
            <div className="mk-finance__tile mk-finance__tile--net">
              <strong className="mk-finance__value">{formatMxn(MOCK_MONEY.net)}</strong>
              <span className="mk-finance__label">
                Neto organizador / club
                <small>Lo que te queda</small>
              </span>
            </div>
          </div>

          <p className="mk-finance__strip">
            <span>
              Total: <b>{MOCK_MONEY.orders}</b>
            </span>
            <span>
              Pagadas: <b>{MOCK_MONEY.paid}</b>
            </span>
            <span>
              Pendientes: <b>{PENDING_ORDERS}</b>
            </span>
          </p>

          <div className="mk-finance__rows">
            <div className="mk-finance__row mk-finance__row--pending">
              <Avatar name="Paola Méndez" />
              <div className="mk-finance__who">
                <strong>Paola Méndez</strong>
                <small>Femenil 4.0</small>
              </div>
              <div className="mk-finance__meta">
                <span className="mk-finance__btn">
                  <CopyGlyph />
                  Copiar recordatorio
                </span>
              </div>
              <div className="mk-finance__amt">
                <strong>{formatMxn(850)}</strong>
                <Pill tone="warn">Pendiente de pago</Pill>
              </div>
            </div>

            <div className="mk-finance__row">
              <Avatar name="Diego Salazar" />
              <div className="mk-finance__who">
                <strong>Diego Salazar</strong>
                <small>Varonil Abierta B + Dobles mixto</small>
              </div>
              <div className="mk-finance__meta mk-finance__meta--info">
                <span>Mercado Pago</span>
                <span>
                  Comisión Torneos123 <b>{formatMxn(99)}</b>
                </span>
              </div>
              <div className="mk-finance__amt">
                <strong>{formatMxn(1250)}</strong>
                <Pill tone="ok">Pago confirmado</Pill>
              </div>
            </div>
          </div>
        </PanelFrame>
      </MockFigure>

      <div className="mk-finance__flow">
        <MoneyFlow />
      </div>
    </div>
  );
}
